import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgBsToastService } from 'ng-bs-toast-service';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-change-password',
    standalone: false,
    templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent {
    
    constructor(
        private authService: AuthService,
        private router: Router,
        private toastService: NgBsToastService,
    ) {}

    readonly emailPattern = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

    email = '';
    loading = false;

    isEmailStructurallyValid(value: string): boolean {
        return this.emailPattern.test(value.trim());
    }

    hasTypedEmail(): boolean {
        return this.email.trim().length > 0;
    }

    private getRecoverPasswordErrorFeedback(err: HttpErrorResponse): { title: string; message: string } {
        const backendMessage = this.getBackendErrorMessage(err);

        if (err.status === 404) {
            return {
                title: 'Email não encontrado',
                message: 'Não localizamos uma conta com esse email.'
            };
        }

        if (err.status === 400) {
            return {
                title: 'Não foi possível enviar o email',
                message: backendMessage || 'Confira o email informado e tente novamente.'
            };
        }

        if (err.status === 0) {
            return {
                title: 'Falha de conexão',
                message: 'Não foi possível se comunicar com o servidor. Tente novamente em instantes.'
            };
        }

        if (err.status >= 500) {
            return {
                title: 'Serviço indisponível',
                message: 'Ocorreu um problema ao enviar o email de recuperação. Tente novamente mais tarde.'
            };
        }

        return {
            title: 'Não foi possível enviar o email',
            message: 'Tente novamente em alguns instantes.'
        };
    }

    private getBackendErrorMessage(err: HttpErrorResponse): string | null {
        if (typeof err.error === 'string' && err.error.trim()) {
            return err.error.trim();
        }

        if (err.error && typeof err.error === 'object') {
            const candidates = [err.error.error, err.error.message, err.error.detail];

            for (const candidate of candidates) {
                if (typeof candidate === 'string' && candidate.trim()) {
                    return candidate.trim();
                }
            }
        }

        return null;
    }

    onSubmit(form: NgForm): void {
        const normalizedEmail = this.email.trim();

        if (this.loading || !this.isEmailStructurallyValid(normalizedEmail)) {
            form.control.markAllAsTouched();
            return;
        }

        this.loading = true;

        const subscription = this.authService.recoverPassword(normalizedEmail).subscribe({
            next: () => {
                this.toastService.send('Sucesso', 'Email de recuperação enviado!', 'success');
                void this.router.navigate(['/login']);
            },
            error: (err: unknown) => {
                if (err instanceof HttpErrorResponse) {
                    const feedback = this.getRecoverPasswordErrorFeedback(err);

                    this.toastService.send(
                        feedback.title,
                        feedback.message,
                        'danger',
                    );
                    return;
                }

                this.toastService.send(
                    'Erro',
                    err instanceof Error
                        ? err.name
                        : 'Erro inesperado, tente novamente mais tarde.',
                    'danger',
                );
            }
        });

        subscription.add(() => {
            this.loading = false;
        });
    }
}
